"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = Object.freeze((0, _keyMirror.default)({
  COS_TEMPLATE: null,
  PACK: null,
  CUSTOM_MODULE: null
}));

exports.default = _default;
module.exports = exports.default;